const routes = [
  {
    name: 'Main',
    path: '/main',
    component: () => import('@/views/public/Main.vue')
  },
  {
    path: '/gazprom-classes/:gpClass',
    name: 'Class',
    meta: { label: '' },
    component: () => import('@/views/public/Class.vue')
  },
  {
    path: '/gazprom-universities/:gpUniver',
    name: 'University',
    meta: { label: '' },
    component: () => import('@/views/public/University.vue')
  },
  {
    name: 'Cookies',
    path: '/cookies',
    component: () => import('@/views/public/Cookies.vue')
  }
]
export default routes
